import axios from 'axios';

export const debitNoteApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/stk-debit-note`,
    headers: {
        'Content-Type': 'application/json'
    }
})